<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Input, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { VirtualComponentInterface } from 'src/types/VirtualComponents';

	export let settings: VirtualComponentInterface['config'];
	export let errorURL: boolean;
</script>

<Text styleType="h2" class="mb-s">
	{$format('virtual_component_title_custom_icon', {
		default: 'Custom Icon URL',
	})}
</Text>
<Input
	aria-label={$format('virtual_component_title_custom_icon', {
		default: 'Custom Icon URL',
	})}
	size="m"
	class="mb-m"
	icon="fas fa-image"
	maxlength="512"
	value={settings?.meta?.ui?.icon || ''}
	error={errorURL
		? $format('enter_valid_url', {
				default: 'Invalid URLs: Please enter a valid URL!',
			})
		: ''}
	on:input={(e) => {
		if (!settings?.meta) settings.meta = { ui: {} };
		settings.meta.ui.icon = e.target['value'];
	}}
	id="input-rvznl8m"
/>
